// Queries
import preOrderUnit from "./PreOrderUnitQuery.gql";

// Mutations
import updatePreOrderUnit from "./UpdatePreOrderUnitMutation.gql";

export const Query = {
    preOrderUnit,
};
export const Mutation = {
    updatePreOrderUnit,
};
